import { parseArrayVariable } from '@/helpers/envs';

const { VUE_APP_SENTRY_DSN: DSN, VUE_APP_SENTRY_ENVS: envs } = process.env;

const ENVS = parseArrayVariable(envs, '|');

export { DSN, ENVS };
